import React from 'react';
import {useTranslation} from "react-i18next";
// import gg from '../../public/images/good-gamers-logo.png';
// import alz from '../../public/images/clients/alz-logo.png';
// import jm from '../../public/images/juan-monte-logo.jpg';

const clientImage = {
    height: '10rem',
    width: 'auto',
    mixBlendMode: 'colorBurn'
}

const Clients = () => {
    const {t} = useTranslation();
    return (
        <div id={"clients"} className="mt-8 bg-white">
            <div className="py-72">
                <section data-aos="fade-up">
                    <div className="my-4 py-4">
                        <h2 className="my-2 text-center text-3xl text-red-900 uppercase font-bold">
                            {t('clients.title')}
                        </h2>
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-blue-900'></div>
                        </div>
                        <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-red-900">
                            {t('clients.description')}
                        </h2>
                    </div>

                    <div className="p-16" data-aos="fade-in" data-aos-delay="600">
                        <div className="grid sm:grid-cols-3 lg:grid-cols-3">

                            <div style={clientImage}
                                 className="overflow-hidden p-3 flex justify-center transition-all ease-in-out opacity-100 hover:opacity-50">
                                <img src={"../../images/clients/good-gamers-logo.png"} alt="client"/>
                            </div>
                            <div style={clientImage}
                                 className="overflow-hidden flex justify-center transition-all ease-in-out  opacity-100 hover:opacity-50 w-1/6">
                                <img src={"../../images/clients/alz-logo.png"} alt="client"/>
                            </div>

                            <div style={clientImage}
                                 className="overflow-hidden p-3 flex justify-center transition-all ease-in-out  opacity-100 hover:opacity-50">
                                <img src={"../../images/clients/juan-monte-logo.jpg"} alt="client"/>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Clients;